<template>
  <page-layout
    title="My Promo Codes"
    :linkDefault="`/${this.user.username}/dashboard`"
  >
    <div :key="update" class="relative">
      <div class="relative min-h-screen">
        <empty
          v-if="!loading && codes?.length === 0"
          class="mt-20"
          :text="'No promo codes created'"
          icon="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAHGElEQVR4nO2cXYxdVRXHf2vvM9ooCJQyvhEwJvTF2IhFgRgTjfENgwoGQQJN6WCnfBmx0PngcO8MtLxUsA2EMXxEQcuDJobEB3mAhAZCFTG+9MlGwJgUtEPiF53ZZ/kwt+0555479+OcM3M7s35PM2vvs/a+95+11zl77XPBMAzDMAzDMAzDMAzDMM4OZDUG1Ya7HZEmsGk1xl8h5hF2yWR4rp+LVlQQjTkH758EbljJcVeR9xkJn5b7+KDXC1yds0mjTS7Du9dYP2IAbOJkFPdzwYpEiM74a1GeBs5bifGGjIC6y2V64U+9dI7qnInGRPhoBtXdBc1/gHCdTHGszjnUjTb9rcBP6bzaeCQ5qMqXRNBu/mpbsjTmYrw/DAViCAcI4aqzXoyG30a7GAkqP4bMl381Tf+9XnzWIog2o6/g/RHgilzTv1BukMlwh8ScrGPslUKb/laEObLfoaI6LtOL9yA8m7lAeERjzu/mt1JBVBFtut2gvwNGs41yFOevlOnwyyrHXA06LFOK6k6ZTp4AwIUfAv9ItX8S3z3BV5bUNWYTkf85ytcLmp9jQxiTe/l3VeOtFj2JcbqvGwc5kDIFnPu8TCy81cl/JRGijZGtRP5IgRgfgt4tU+Gm9SYGACF5HHgjZfEkyQHVzoFQWhBt+B1I8irKJbmmt1H3ZZlKHi07xjDQtxiAxCSIGweSlPlqZv3NncYZeMnSfZzLST8HfKeg+UWicLPcz4lB/Q8Tg4iRuX7Gz6FsT5mOE8JlEjOf7ztQhOhDbObD6HXaxQggDxLCN0yMFIthN/B+yjKK942irn1HiDb8TQhPAB/PNR0HuVGmFl/q1+ewUokYp325MZD0NQF1W2V64Y/pfj1HiD7GR7URPYrwM9rFeAUXtpgYyxCSOeD1lMUj7Qm+J0E05mI+8K8geme+CZXHGA1fkwn+3vckh5TKxaCV4NXtAkLKfBUz/pZMvx4mdw3wLHR/ylzDJCi3yXR4qqwjnfGPo9yeMh0nCptP5dxlI0RjzgGewsSoRAwAFsME8F7KMkrwM6f+WX7Jitwu4MJKJnL28pvKxAAk5p8o92WMypjOjnwOllmyWtW9vwAXVTWZs5TCu6EyqCLM+MPAlSnzEUL4YmdBZtweVGbzdpkKq1KHXym06YtqFktfVpx54i43TuMjn0HCm2RrUtsLlyzdx7mo/KCqwdcAW3HZu6GyyPTJPwMvZo3sKc4hC+4OLHdkEfZqzMaq3LWKW9dkjWxoE0RjPmHRUchFRL5tCR8EbfhtBcWtBOXe9giJ3J1YdBSj7NCZkXwVtD8Xy1Yaw/MZQVrRcU+ZAdcgh1N/OzT5icYDbsp2rMGz/dQOQNbxUnSk18m27eF1h2vb7rgC57d36t6JZZapzEPn6cbi6JA1UVwqQ6vcmt2/Eh7WuPdjsF2WqcxD55l7YO/uIh8dYfEZvH+gj/l3n1wj2tfapNxQpV/gGAnj8kD4bcV+IYRJvL+OMwc3NhL5hyHc1u3S1jLVITKSth0AB6B7OQ9y0SHM431lT6cAOjuyBdEfUb0YAJfimKvBL63KXn67Y5s2Rr6w3HW9LlNpljouuruAC3IDXsL63lTMMhmeAV5LWRySHNQX8EXdBxEDwGnM+St1ZyUTC2+hshf4Tw3uj5HQdQkZFBEUdeNkE/zlHHVj+b6DigEg2oxi0J7zxHrby8p/Xp3xB1F2pkwnCGGzxBxvXV+quOVAd3Zomwd5sKdPsZ7wYZJsPeMCvN8LvT1ndMPRfgJ+vnVy5FKZWuzr3Yb1gNzPibZ6BtyijWh/wTJFv8Uth/B94ATwXlqIojNDRoup8DTZBC+I3k1Bwa/f4lYkk+EQcKjcDNcXIqjOul0kyRtQfJc1KCv2SttaQyYW3gSerNqvCVKGqO3AQumKoglSgqWjO3I9cAx4F+XGsj5rfcdwPSBTiy8Dnzr1vzb9L8r4swgZMkyQIcMEGTJMkCHDBBkyTJAhwwQZMkyQIcMEGTJMkCHDBBkyTJAhwwSpEJ0d2VLWhwlSEfoQF6LJr3Pmv/XrxwSpAI2JSPyhth/gEYp+2nBZTJAqcNE+lK9mjbK/39/sBROkNNrw30U0/8bZq4wu9h0dYIKUQhsjn22dxUrzNj58U8ZYGMSnCTIgGrMRl/wK+FjK/D/EfUv2ZA4+9IUJMgD6Ap7IP4+eqaW32CmTC78v49sEGYSj0SPtvy8p+2XpRGMpTJA+qTqJ5zFB+qCOJJ7HBOmRupJ4HhOkB+pM4nlMkF6oMYnnMUG6UHcSz2OCdKM9if+1yiSexwTpTj6Jf7vKJJ7HBOmPypN4HhOkZ+pJ4nn6fj+kw28SrnVqS+J5LEK6U+mTeDd6EeTd2mcxvPwX566tM4nn6S5Iwg7gnfqnMnS8A1zfetvWMAzDMAzDMAzDMAzDMIwc/wfO2Lq8F2TkNQAAAABJRU5ErkJggg=="
        />
        <transition-group
          v-else-if="!loading"
          tag="ul"
          name="scale-up"
          appear
          class="relative md:grid md:grid-cols-2 w-full"
        >
          <li v-for="(code, index) in codes" :key="index" class="p-4">
            <Promocode
              :promo="code.promo"
              :times_used="code.times_used"
              :times_remaining="code.times_remaining"
            />
          </li>
        </transition-group>

        <CreatePromocode @create="codes.unshift($event)" />
      </div>
    </div>
  </page-layout>
</template>

<script >
import PageLayout from "../components/base/pageLayout.vue";
import { mapState } from "vuex";
import Empty from "../components/empty.vue";
import GetPromo from "../GetPromo";
import Promocode from "../components/promocode.vue";
import CreatePromocode from "../components/modals/createPromocode.vue";

export default {
  components: {
    PageLayout,
    Empty,
    Promocode,
    CreatePromocode,
  },
  computed: {
    ...mapState(["user", "user_tutor"]),
  },
  data() {
    return {
      codes: [],
      loading: true,
      update: 0,
    };
  },
  created() {
    GetPromo.getProductCodes(this.user.email).then((data) => {
      this.codes = data.reverse();
      this.loading = false;
      this.update++;
    });
  },
};
</script>